import React, { useEffect, useRef } from 'react';
import Float from './Float';
import Label from './Label';
import Button from './Button';
import ModalButton from './ModalButton';

const Modal = (props) => {

    const { frame = true, className = "", alert = false, mask_close = false, align = "top", refElement = false, closable = false, title = "", callback = () => { }, component, offset = [0, 0] } = props;

    // const modalRef = useRef(null);

    let _classname = "ui-modal";

    if (className) {
        _classname += " " + className;
    }

    const handleClick = (e) => {

       
        if (e.target.getAttribute("data-mask-click") === "true") {
            callback(false);
        }
    }


    if(frame){
        return(<><div style={{ "justifyContent": "left", "alignItems": "start" }} className='ui-blank-screen'>
                    <div
                        style={{
                            display: "flex",
                            width: "100%",
                            justifyContent: "center",
                            margin: "0 auto",
                            paddingTop: "clamp(43px, calc((100vh - 514px) / 2), 67px)",
                            boxSizing: "border-box",
                        }}
                    >
                        <div
                            style={{
                                height: "calc(100vh - 75px)",
                                maxHeight: "calc(100vh - clamp(0px, calc((100vh - 514px) / 2), 26px))",
                                width: "min(100%, 1440px)",
                                minWidth: "1180px",
                                minHeight: "557px",
                                backgroundColor: "#00000088",
                                flexShrink: 0,
                            }}
                        >
                               {React.cloneElement(component, { callback: callback })}
                        </div>
                    </div>
                </div></>)
    }

    if (refElement || alert) {





        let style = {}

        if (refElement) {
            const { bottom, left, top } = refElement.getBoundingClientRect();
            style.position = 'absolute';
            style.left = `${(left + offset[1]) + window.scrollX}px`;

            if (align === "bottom") {
                style.bottom = `${window.innerHeight - top + offset[0] - window.scrollY}px`;
            } else {
                style.top = `${(bottom + offset[0]) + window.scrollY}px`;
                
            }
        }



        return (
            <div data-bg="bg" className={_classname} style={{ "alignItems": "center" }}>
               
                <div data-mask-click={mask_close} onClick={(e) => handleClick(e)} className="ui-modal-overlay" style={{ "alignItems": "center" }}>
                    <div style={style} >{React.cloneElement(component, { callback: callback })}</div>
                </div>
            </div>
        );
    }


    return (
        <div className="ui-modal" style={{ "alignItems": "center" }}>
            <div data-mask-click={mask_close} onClick={(e) => handleClick(e)} className="ui-modal-overlay" style={{ "alignItems": "center" }}>
                <div
                    className="ui-modal-content"
                // ref={modalRef}
                // tabIndex={-1} // Allows the element to be focused
                >
                    <div className="ui-modal-header">
                        <div style={{ "padding": "0px 10px", "paddingBottom": "5px", "width": "100%" }}>
                            <Float>
                                <Label>{title}</Label>
                                {(closable && <ModalButton onClick={() => callback()} style={{ "marginTop": "-2px" }} value={<>&times;</>} />)}
                            </Float>
                        </div>
                    </div>
                    <div className="ui-modal-body">{React.cloneElement(component, { callback: callback })}</div>
                </div>
            </div>
        </div>
    );
};

export default Modal;
